<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Jose martin de la cruz vicencio
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card title="Catalógo de Profesores">

                <!-- Formulario -->
                <vs-popup  class="holamundo"  title="" :active.sync="formModal">

                    <vx-card title="Datos del profesor" style="height:500px" >
                        

                        <!-- CAMPOS -->
                        <form>
                            <vs-input name="id" type="hidden" :value="form.id" v-model="form.id"  />
                            <div class="container">
                                <div class="row">
                                    <div class="col-3">Clave</div>
                                    <div class="col-9">
                                        <vs-input v-validate="'required'" placeholder="Clave" name="clave" :disabled="form.id" type="number" v-model="form.clave" />
                                        <span class="text-danger text-sm" v-show="errors.has('clave')">{{ errors.first('clave') }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">Nombre</div>
                                    <div class="col-9">
                                        <vs-input v-validate="'required'" placeholder="Nombre" name="nombres" v-model="form.nombres" />
                                    <span class="text-danger text-sm" v-show="errors.has('nombres')">{{ errors.first('nombres') }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">Apellido paterno</div>
                                    <div class="col-9">
                                        <vs-input v-validate="'required'" placeholder="Apellido Paterno" name="apellidoPaterno" v-model="form.apellidoPaterno" />
                                    <span class="text-danger text-sm" v-show="errors.has('apellidoPaterno')">{{ errors.first('apellidoPaterno') }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">Apellido materno</div>
                                    <div class="col-9">
                                        <vs-input v-validate="'required'" placeholder="Apellido Materno" name="apellidoMaterno" v-model="form.apellidoMaterno" />
                                    <span class="text-danger text-sm" v-show="errors.has('apellidoMaterno')">{{ errors.first('apellidoMaterno') }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">Correo</div>
                                    <div class="col-9">
                                        <vs-input v-validate="'required'" placeholder="Correo" name="correo" v-model="form.correo" />
                                    <span class="text-danger text-sm" v-show="errors.has('correo')">{{ errors.first('correo') }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">Contraseña</div>
                                    <div class="col-9">
                                        <vs-input placeholder="contraseña" name="contrasegna" type="password" v-model="form.contrasegna" class="mt-5" />
                                        <span class="text-danger text-sm" v-show="errors.has('contrasegna')">{{ errors.first('contrasegna') }}</span>
                                    </div>
                                </div>

                                
                                <div class="row">
                                    <div class="col-3">Tipo de contrato</div>
                                    <div class="col-9">

                                        <v-select v-validate="'required'" style="width: 100%;" label="tipoContrato" name="idTipoContrato" v-model="form.idTipoContrato" :options="tiposContrato"></v-select>
                                        <span class="text-danger text-sm" v-show="errors.has('idTipoContrato')">{{ errors.first('idTipoContrato') }}</span>
                                    </div>
                                </div>



                                         <div class="row">
                                    <div class="col-3">Carrera</div>
                                    <div class="col-9">
                               <!-- <v-select class="float-left" style="width: 100%;" label="nombre" v-model="carreraListSelected" :options="carreras"></v-select> -->
                    <v-select v-validate="'required'" style="width: 100%;" label="nombre" name="idCarrera" v-model="form_carrera.idCarrera" :options="carreras"></v-select>
                                    <span class="text-danger text-sm" v-show="errors.has('idCarrera')">{{ errors.first('idCarrera') }}</span>

                                    </div>
                                </div>

                              
                              
                        
                            
                                <div class="row">           
                                    <vs-button type="filled" @click.prevent="submitForm" class="mt-5 block">Guardar</vs-button>
                                </div>
                            </div>
                        </form>
                    </vx-card>
                   
                </vs-popup>
            <!-- Termina formulario -->

                        <div style="text-align: right;">
                            <p>
                                    <vs-button class="" style="margin: 3px;"  v-show="id_rol==1 || id_rol==2 || id_rol==6" @click="agregar()">Agregar </vs-button>
                                    
                               </p>
                           </div>
                           <div class="flex-centered">

                                <vs-table search pagination :maxItems="150" stripe :data="dataProfesores">

                                   <template slot="thead">
                                       <vs-th>Clave</vs-th>
                                       <vs-th>Nombres</vs-th>
                                       <vs-th>Apellido paterno</vs-th>
                                       <vs-th>Apellido materno</vs-th>
                                       <vs-th>Correo</vs-th>
                                       <vs-th>Tipo de contrato</vs-th>
                                        <vs-th sort-key="activo">Status</vs-th>
                                       <vs-th>Editar</vs-th>
                                       <vs-th>Borrar</vs-th>
                                   </template>

                                   <template slot-scope="{data}">
                                       <!-- <vs-tr :key="indextr" v-for="(tr, indextr) in data"> -->
                                     <vs-tr :state="data[indextr].activo == 1 ? 'success':data[indextr].activo == 0 ? 'danger':null" :key="indextr" v-for="(tr, indextr) in data">
                
                                           <vs-td :data="data[indextr].id">
                                               {{data[indextr].clave}}
                                           </vs-td>
                                           <vs-td :data="data[indextr].id">
                                               {{data[indextr].nombres}}
                                           </vs-td>
                                           <vs-td :data="data[indextr].id">
                                               {{data[indextr].apellidoPaterno}}
                                           </vs-td>
                                           <vs-td :data="data[indextr].id">
                                               {{data[indextr].apellidoMaterno}}
                                           </vs-td>
                                           <vs-td :data="data[indextr].id">
                                               {{data[indextr].correo}}
                                           </vs-td>
                                           <vs-td :data="data[indextr].id">
                                               {{data[indextr].tipoContrato}}
                                           </vs-td>

                                          <vs-td :data="data[indextr].id">
                                                                                     

                              <div v-if="data[indextr].activo==1">
                                 SI
                                 </div> 
                                      <div v-else >
                                        NO
                                        </div>  
                                   </vs-td>
                                      <vs-td :data="data[indextr].id">
                                                 <vs-button  v-show="id_rol==1 || id_rol==2" radius color="success" type="gradient" icon-pack="feather" icon="icon-edit"  @click="editar(data[indextr].id)"></vs-button>


                                           </vs-td>
                                           <vs-td :data="data[indextr].id">
                                                 <vs-button  v-show="id_rol==1" radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash"  @click="borrar(data[indextr].id)"></vs-button>


                                           </vs-td>
                                        
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
        </vx-card>

</template>

<style scoped>

</style>

<script>
    import vSelect from 'vue-select'
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'


    import Table from "../ui-elements/table/Table";

    import DragItDude from "vue-drag-it-dude";
    import Button from "../components/vuesax/button/Button";

    export default {
        data() {
            return {    
                id_rol: this.getKey('id_rol'),
                formModal:false,
                idToDelete:'',
                dataProfesores:[],
                form: {},
                form_carrera:{},
                tiposContrato:[],
                 carreras: [],
            }
        },
        components: {
            Button,
            Table,
            'v-select': vSelect,
            FormWizard,
            TabContent,
            DragItDude
        },
        created() {
      if(this.id_rol == 1 || this.id_rol == 2 || this.id_rol == 6){
            this.getTiposContrato();
            this.getProfesores();
             this.getCarreras();

                     }
        },
        mounted(){
        },
        watch: {
            
        },
        
        methods: {
                      
            getCarreras() {
                this.$http.get("carreras").then(
                    response => {
                        this.carreras = response.data.carreras;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            submitForm() {
                this.$validator.validateAll().then(result => {
                    if(result) {
                       let tokenStorage=localStorage.getItem('app-token');

                        this.$http.post("catalogos/save_profesores",{token:tokenStorage,data:this.form,data_form_carrera:this.form_carrera}).then(
                            response => {
                                if(response.data.resultado==="ok"){ 
                                    this.$vs.notify({ color: 'success', title: 'Registro guardado', text: 'Se guardo el registro correctamente' });
                                    this.form={};
                                    this.formModal=false;
                                    this.getProfesores();

                                }else{
                                    this.$vs.notify({
                                        time: 2600,
                                        title: 'Nota',
                                        text: response.data.resultado,
                                        iconPack: 'feather',
                                        icon: 'icon-alert-circle',
                                        color: 'danger'
                                    });
                                }
                                
                            },
                            error => {
                                if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                                this.$router.push({name:'pageLogin'});
                                localStorage.clear();
                                location.reload()
                                }
                                this.StepError(error);
                            }
                        );
                    }else{
                        // form have errors
                    }
                });
            },
            agregar(){
                this.form={};
                this.formModal=true;
            },
            editar(id){
                this.$http.get("catalogos/get_profesor/"+id).then(
                    response => {
                        this.form = response.data.profesor;
                        this.formModal=true;


                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            borrar(id) {
                this.idToDelete=id;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirm`,
                    text: '¿Está seguro de borrar el registro?',
                    accept: this.realizarBorrado
                });
            },
            realizarBorrado() {
                let tokenStorage=localStorage.getItem('app-token');

                this.$http.post("catalogos/delete_profesor",{token:tokenStorage,id:this.idToDelete}).then(
                    response => {
                        if(response.data.resultado==="ok"){ 
                            this.$vs.notify({
                                            color: 'danger',
                                            title: 'Registro borrado',
                                            text: 'El borrado del registro fue realizado'
                                        });
                                        this.getProfesores();
                        }else{
                            this.$vs.notify({
                                time: 2500,
                                title: 'Nota',
                                text: 'Ocurrio un error',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            });
                        }
                        
                    },
                    error => {
                        if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                        this.$router.push({name:'pageLogin'});
                        localStorage.clear();
                        location.reload()
                        }
                        this.StepError(error);
                    }
                );
                
            },
            getTiposContrato(){
                this.$http.get("catalogos/get_tipos_contrato").then(
                    response => {
                        this.tiposContrato = response.data.tipos;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            getProfesores(){
                this.$http.get("catalogos/get_profesores").then(
                    response => {
                        this.dataProfesores = response.data.profesores;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
    },
    }
</script>


